import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 13 13.1" fill="currentColor">
            <path
                fill="#75b8c8"
                d="M2.7 13.1c-.5 0-1.1-.4-1.5-.6-.5-.3-.9-.8-1.1-1.1C-.6 10 1 7 4 4c2.4-2.4 5-4 6.5-4 .4 0 .7.1.9.3.5.3 2 1.9 1.6 2.9-.2.6-2.8 2-3.3 2h-.2c-.2-.1-.5-.3-.9-.5-.3-.2-.6-.4-.8-.4-.2 0-1 .6-2 1.6-.5.4-.9.9-1.2 1.3-.4.5-.4.7-.4.7.1.1.3.5.5.8l.4.8v.2c0 .5-1.5 3.1-2.1 3.3 0 0-.2.1-.3.1zM10.4 1c-1 0-3.2 1.2-5.7 3.7-3 3-4 5.5-3.6 6.1.1.2.5.6.8.8.5.3.8.4.9.4.2-.2 1.2-1.8 1.4-2.4-.2 0-.3-.3-.4-.4-.3-.4-.4-.8-.5-1-.2-.4 0-.9.5-1.6.3-.4.8-1 1.3-1.5.8-.8 2-1.8 2.7-1.8.1 0 .2 0 .3.1l1 .5.6.3C10.1 4 11.8 3 12 2.7c0-.2-.7-1.2-1.3-1.6 0-.1-.1-.1-.3-.1z"
            />
        </svg>
    );
};

export default React.memo(Phone);
